// Copyright © 2025 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'
import { Routes, Route, useParams } from 'react-router-dom'

import Breadcrumb from '@ttn-lw/components/breadcrumbs/breadcrumb'
import { useBreadcrumbs } from '@ttn-lw/components/breadcrumbs/context'

import ErrorView from '@ttn-lw/lib/components/error-view'
import ValidateRouteParam from '@ttn-lw/lib/components/validate-route-param'
import GenericNotFound from '@ttn-lw/lib/components/full-view-error/not-found'

import SubViewError from '@console/views/sub-view-error'
import ApplicationMacSettingsProfilesList from '@console/views/application-mac-settings-profiles-list'
import ApplicationMacSettingsProfilesAdd from '@console/views/application-mac-settings-profile-add'
import ApplicationMacSettingsProfilesEdit from '@console/views/application-mac-settings-profile-edit'

import sharedMessages from '@ttn-lw/lib/shared-messages'

import { macSettingsProfileId } from '@console/lib/regexp'

const ApplicationMacSettingsProfiles = () => {
  const { appId } = useParams()

  useBreadcrumbs(
    'apps.single.mac-settings-profiles',
    <Breadcrumb
      path={`/applications/${appId}/mac-settings-profiles`}
      content={sharedMessages.macSettingsProfiles}
    />,
  )

  return (
    <ErrorView errorRender={SubViewError}>
      <Routes>
        <Route index Component={ApplicationMacSettingsProfilesList} />
        <Route path="/add" Component={ApplicationMacSettingsProfilesAdd} />
        <Route
          path="/:macSettingsProfileId"
          element={
            <ValidateRouteParam
              check={{ macSettingsProfileId }}
              otherwise={{ redirect: `/applications/${appId}/mac-settings-profiles` }}
              Component={ApplicationMacSettingsProfilesEdit}
            />
          }
        />
        <Route path="*" element={<GenericNotFound />} />
      </Routes>
    </ErrorView>
  )
}

export default ApplicationMacSettingsProfiles
